import React, {useState, useEffect, useRef} from 'react'
import {  Grid, Button, Box, Typography, Card, MenuItem, CardContent, Autocomplete as AutoComplete } from "@mui/material" ;
import { profileSettingStyles } from '../../../styles/materialComponent';
import { CssTextField } from '../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import {fetchClients} from "../../../actions/client"
import { useNavigate, useLocation } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { AddProperty } from '../../../actions/property';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { validateUserType } from '../../../ValidateUserType';
import { fetchArbors } from '../../../actions/arboristLogin';

const libraries = ['places'];

const AddProperties = () => {   
  const autocompleteRef = useRef(null)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const classes = profileSettingStyles()
    const {clients} = useSelector(({client})=> client)
    const {arbors}=useSelector(({arbor})=>arbor)//for company

    const [property, setProperty] = useState({
      propertyName:"",
      client:"",
      location:"",
      propertyLat:""  ,
      propertyLong:"",   
      selectArbor:arbors?.length?arbors[0]._id:""
    })
    

    useEffect(()=>{
      location?.state?.client && setProperty({...property, client:location?.state?.client})
    },[])

    useEffect(()=>{
      if(validateUserType()){
        dispatch(fetchArbors())
      }
      else{
        dispatch(fetchClients())
      }
    },[])

    useEffect(()=>{
      property.selectArbor&&property.selectArbor!==""&&dispatch(fetchClients(property.selectArbor))
     },[property.selectArbor])
    
    const handleChange =(e)=>{
      const {name, value} = e.target
      setProperty({...property, [name]:value})
    }

    const handleClientChange =(e, v)=>{
      setProperty({...property, client:v})
    }

      const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries
    });
    
      const onLoadAutocomplete = (autocomplete) => {
        autocompleteRef.current = autocomplete;
    }
    const onPlaceChanged = () => {
      const  place  = autocompleteRef.current.getPlace();
      if(place) { 
        const lat = place.geometry.location.lat()
        const lng = place.geometry.location.lng() 
        setProperty({...property, location: place.formatted_address, propertyLat:lat, propertyLong:lng })
      } 
    }
    const handleSubmit =(e)=>{
      e.preventDefault()
      if(validateUserType() && !property.selectArbor){
        NotificationManager.error("All fields are required")
       }
        if(!property.propertyName || !property.client || !property.location){
          NotificationManager.error("All fields are required")
        }else{
          const properties ={
            propertyName:property.propertyName,
            client: property.client?._id,
            location: property.location,
            propertyLat:property.propertyLat ,
            propertyLong: property.propertyLong 
          }
          if(validateUserType()){
            properties.arborist=property.selectArbor
          }
          dispatch(AddProperty(properties, navigate, location))
        }
      }
     
    
   
    if (!isLoaded) {
      return <div>Loading...</div>;
    }
    
  return (
      <Grid container justifyContent="center">
      <Grid item xs={12} sm={12} md={8} lg={8}>
      <Card
        style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:8, backgroundColor:"#FCFBFD"}}
      >    
      <CardContent>
      <Box className={classes.profileText}>
        <Typography variant="h4" fontFamily="CormorantBoldItalic" style={{marginTop:50}}>Add Property</Typography>
      </Box>
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>

        {validateUserType() &&  <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Select Arbor"
          name="selectArbor"
          value={property.selectArbor}
          onChange={handleChange}
        >
          <MenuItem value="" disabled>
            <em>None</em>
          </MenuItem>
          {arbors.length>0 && arbors.map((op)=>
          <MenuItem value={op._id}>{op.firstName}</MenuItem>
          )}
      </CssTextField>
      </Grid>}

        
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField        
          className={classes.textField1}
          required
          variant="outlined"
          label="Property Name"    
          name="propertyName" 
          value={property.propertyName}
          onChange={handleChange}    
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
      <div className={classes.textField1} >
       <Autocomplete
          onLoad={onLoadAutocomplete}
          onPlaceChanged={onPlaceChanged}
        >
      <CssTextField
        style={{width:"100%"}}
        variant="outlined"
        label="Address"
        type='text'
        name="location"
        value={property.location}
        onChange={handleChange} 
      />
      </Autocomplete>
      </div>
      </Grid>    
       {/* <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          className={classes.textField1}
          variant="outlined"
          label="location"   
          name="location"       
          value={property.location}
          
          onChange={handleChange} 
        />
      </Grid> */}
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      {/* <Autocomplete
          disablePortal
          id="combo-box-demo"
          options = {clients}
          name="client"
          className={classes.textField1}
          getOptionLabel={ (client: Object | string) => client['clientName'] || client }
          getOptionSelected={(option, value) => option._id === value}
          value = {property.client?.clientName}
          onChange={handleClientChange}
          renderInput={(params) => <CssTextField {...params}  name="client" label="Client"/>}
        /> */}
      <AutoComplete
          disablePortal       
          id="combo-box-demo"
          options={clients}
          name="client"
          disabled = {location?.state?.data === "/addReport" || location.state?.data ==="/editReport" ? true : false}
          value = {location?.state?.client ? location?.state?.client?.clientName : property.client?.clientName}
          className={classes.textField1}
          getOptionLabel={ (client) => client['clientName'] || client }
          getOptionSelected={(option, value) => option._id === value._id}
          onChange={handleClientChange}
          renderInput={(params) => <CssTextField {...params}  name = "client" label = "Client" />}
        />
      </Grid>       
       <Grid item xs={12} sm={12} md={6} lg={6} className={classes.grid} style={{margin:"auto"}}>
      <Button
        className={classes.submitButton1}
        style={{backgroundColor:"rgb(115 74 153)"}}
        size="large"
        variant="contained"
        onClick={handleSubmit}
      >
        Add
      </Button>      
      <Button
      // type="reset"
        sx={{ml:2}}
        className={classes.cancelButton1}
        style={{backgroundColor:"lightgray", color:"black"}}          
        size="large"
        variant="contained"
        onClick={()=>navigate(-1)}
      >
        Cancel
      </Button>
    </Grid>
      </Grid>
      </CardContent>        
    </Card>
    </Grid>
    </Grid>
  )
}

export default AddProperties